import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { router } from './router';
import { AuthProvider } from './auth/AuthProvider';
import { ToastProvider } from './hooks/useToast';
import { Toaster } from './ui/Feedback';
import { RouteAnnouncer } from './layout/RouteAnnouncer';
import { ApiError } from './api/client';
import './global.css';

/**
 * A 4xx is an answer, not a transport failure: retrying a 422 produces the same 422 and makes a
 * user wait three times for it.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('The mount point is missing from index.html.');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
          <ToastProvider>
          <RouteAnnouncer />
          <RouterProvider router={router} />
          <Toaster />
          </ToastProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
